<ng-template
    [ngIf]="loading()"
    [ngIfElse]="loadUsers">
    <st-loader
        class="st-manage-team-members-loader"
        [productLabel]="languageSettings.PSTWebLoadingLabel"
        [diameter]="200"
        [strokeWidth]="10" />
</ng-template>
<ng-template #loadUsers>
    <mat-tab-group
        animationDuration="0ms"
        (selectedTabChange)="onTabChanged($event)">
        <mat-tab *ngFor="let item of userGroups[groupByField]?.keys; let i = index">
            <ng-template matTabLabel>
                <div class="st-manage-team-members-tab-label">{{ item?.display }}</div>
                <div class="st-manage-team-members-tab-counter">{{ '(' + userGroups[groupByField].entries[item.value]?.length + ')' }}</div>
            </ng-template>

            <table
                mat-table
                class="st-manage-team-members-tab-table"
                [dataSource]="userGroups[groupByField].getItemsForCurrentPage(item.value)">
                <ng-container matColumnDef="Avatar">
                    <th
                        *matHeaderCellDef
                        mat-header-cell>
                        {{ '' }}
                    </th>
                    <td
                        *matCellDef="let user"
                        mat-cell>
                        <st-avatar
                            big
                            [userId]="user.UserID" />
                    </td>
                </ng-container>
                <ng-container matColumnDef="ID">
                    <th
                        *matHeaderCellDef
                        mat-header-cell>
                        {{ languageSettings.PSTWebUserHeaderIDLabel }}
                    </th>
                    <td
                        *matCellDef="let user"
                        mat-cell
                        [class.is-disabled]="!user.Active">
                        {{ user.UserID }}
                    </td>
                </ng-container>
                <ng-container matColumnDef="First Name">
                    <th
                        *matHeaderCellDef
                        mat-header-cell>
                        {{ languageSettings.PSTWebUserHeaderFirstNameLabel }}
                    </th>
                    <td
                        *matCellDef="let user"
                        mat-cell>
                        <st-text-field
                            class="st-manage-team-members-tab-table__text-field"
                            [value]="user.GivenName"
                            [disabled]="!user.Active"
                            (changed)="valueChanged(user, $event, PSTFieldNames.UserInfoGivenName)" />
                    </td>
                </ng-container>

                <ng-container matColumnDef="Last Name">
                    <th
                        *matHeaderCellDef
                        mat-header-cell>
                        {{ languageSettings.PSTWebUserHeaderLastNameLabel }}
                    </th>
                    <td
                        *matCellDef="let user"
                        mat-cell>
                        <st-text-field
                            class="st-manage-team-members-tab-table__text-field"
                            [value]="user.Surname"
                            [disabled]="!user.Active"
                            (changed)="valueChanged(user, $event, PSTFieldNames.UserInfoSurname)" />
                    </td>
                </ng-container>

                <ng-container matColumnDef="Email">
                    <th
                        *matHeaderCellDef
                        mat-header-cell>
                        {{ languageSettings.PSTWebUserHeaderEmailLabel }}
                    </th>
                    <td
                        *matCellDef="let user"
                        mat-cell
                        [matTooltip]="user.Email">
                        <st-text-field
                            class="st-manage-team-members-tab-table__text-field"
                            [value]="user.Email"
                            [disabled]="!user.Active"
                            (changed)="valueChanged(user, $event, PSTFieldNames.UserInfoEmail)" />
                    </td>
                </ng-container>

                <ng-container matColumnDef="SSO Logins">
                    <th
                        *matHeaderCellDef
                        mat-header-cell>
                        {{ languageSettings.PSTWebUserHeaderSSOEmailLabel }}
                    </th>
                    <td
                        *matCellDef="let user"
                        mat-cell
                        [matTooltip]="user.SSOLogins">
                        <st-text-field
                            class="st-manage-team-members-tab-table__text-field"
                            [value]="user.SSOLogins"
                            [disabled]="!user.Active"
                            (changed)="valueChanged(user, $event, PSTFieldNames.UserInfoSSOLogins)" />
                    </td>
                </ng-container>

                <ng-container matColumnDef="Default Team">
                    <th
                        *matHeaderCellDef
                        mat-header-cell>
                        {{ languageSettings.PSTWebUserHeaderDefaultTeamLabel }}
                    </th>
                    <td
                        *matCellDef="let user"
                        mat-cell>
                        <mat-select
                            class="st-manage-team-members-tab-table__mat-select"
                            [disabled]="!user.Active"
                            [(ngModel)]="user.Program"
                            (selectionChange)="saveMember(user)">
                            <mat-option
                                *ngFor="let program of programs"
                                [value]="program.ID">
                                {{ program.Description }}
                            </mat-option>
                        </mat-select>
                    </td>
                </ng-container>

                <ng-container matColumnDef="Role">
                    <th
                        *matHeaderCellDef
                        mat-header-cell>
                        {{ languageSettings.PSTWebUserHeaderRoleLabel }}
                    </th>
                    <td
                        *matCellDef="let user"
                        mat-cell>
                        <mat-select
                            class="st-manage-team-members-tab-table__mat-select"
                            [disabled]="!user.Active"
                            [(ngModel)]="user.GlobalRole"
                            (selectionChange)="selectRole(user)">
                            <mat-option
                                *ngFor="let role of roles"
                                [value]="role.ID">
                                {{ role.Description }}
                            </mat-option>
                        </mat-select>
                    </td>
                </ng-container>

                <ng-container matColumnDef="Status">
                    <th
                        *matHeaderCellDef
                        mat-header-cell>
                        {{ languageSettings.PSTWebUserHeaderStatusLabel }}
                    </th>
                    <td
                        *matCellDef="let user"
                        mat-cell>
                        <mat-select
                            class="st-manage-team-members-tab-table__mat-select"
                            [(ngModel)]="user.Active"
                            (selectionChange)="saveMember(user)">
                            <mat-option
                                *ngFor="let item of InvitationStatusCodes.ACTIVE_STATUS_VALUES"
                                [value]="item.value">
                                {{ item.label }}
                            </mat-option>
                        </mat-select>
                    </td>
                </ng-container>

                <ng-container matColumnDef="Invitation Status">
                    <th
                        *matHeaderCellDef
                        mat-header-cell>
                        {{ '' }}
                    </th>
                    <td
                        *matCellDef="let user"
                        mat-cell>
                        <button
                            class="st-manage-team-members-button-invite"
                            [class.st-manage-team-members-button-invite-disabled]="user.InvitationStatus === InvitationStatusCodes.ACTIVE || !user.Email"
                            [disabled]="user.InvitationStatus === InvitationStatusCodes.ACTIVE || !user.Email"
                            (click)="sendInvitation(user)">
                            {{ invitationButtonLabel(user) }}
                        </button>
                    </td>
                </ng-container>

                <ng-container matColumnDef="Delete">
                    <th
                        *matHeaderCellDef
                        mat-header-cell>
                        {{ '' }}
                    </th>
                    <td
                        *matCellDef="let user"
                        mat-cell>
                        <button
                            mat-icon-button
                            (click)="deleteItem(user)">
                            <mat-icon class="st-manage-team-members-button--delete">delete_outline</mat-icon>
                        </button>
                    </td>
                </ng-container>

                <tr
                    *matHeaderRowDef="displayedColumns"
                    mat-header-row></tr>
                <tr
                    *matRowDef="let row; columns: displayedColumns; let odd = odd"
                    mat-row
                    [class.is-odd]="odd"></tr>
            </table>
        </mat-tab>
    </mat-tab-group>
</ng-template>

<ng-template #mainCta>
    <mat-button-toggle-group class="st-manage-team-members-main-cta-button-group">
        <mat-button-toggle
            class="st-manage-team-members-button-new-member"
            (click)="openNewMemberDialog()">
            <mat-icon class="material-symbols-outlined"> add </mat-icon>
            {{ languageSettings.PSTWebNewMemberLabel }}
        </mat-button-toggle>
    </mat-button-toggle-group>
</ng-template>
<ng-template #viewOptions>
    <ng-container>
        <st-list-drop-down
            *ngIf="predefineFilters.sorting"
            class="left"
            mobileIcon="sort"
            [label]="languageSettings?.PSTWebSortByLabel"
            [value]="sortByField"
            [list]="predefineFilters.sorting"
            (valueOutput)="sortByField = $event" />
    </ng-container>
</ng-template>
<ng-template #rightSlot>
    <div class="st-manage-team-members-paginator">
        <button
            mat-icon-button
            (click)="navigate(NavigationDirection.FIRST, currentGroup)">
            <mat-icon>first_page</mat-icon>
        </button>
        <button
            mat-icon-button
            (click)="navigate(NavigationDirection.PREVIOUS, currentGroup)">
            <mat-icon>navigate_before</mat-icon>
        </button>
        <button
            mat-button
            class="st-manage-team-members-paginator-button-add"
            [matMenuTriggerFor]="listDropDownMenu">
            Page {{ pageIndexToShow }} of {{ totalCount(currentGroup) }}
        </button>
        <mat-menu
            #listDropDownMenu="matMenu"
            class="st-manage-team-members-paginator-menu">
            <form>
                <mat-selection-list
                    hideSingleSelectionIndicator
                    [multiple]="false"
                    (selectionChange)="onPageChanged(currentGroup, $event)">
                    <mat-list-option
                        *ngFor="let item of pages(currentGroup); let i = index"
                        [value]="i">
                        Page {{ item }}
                    </mat-list-option>
                </mat-selection-list>
            </form>
        </mat-menu>
        <button
            mat-icon-button
            (click)="navigate(NavigationDirection.NEXT, currentGroup)">
            <mat-icon>navigate_next</mat-icon>
        </button>
        <button
            mat-icon-button
            (click)="navigate(NavigationDirection.LAST, currentGroup)">
            <mat-icon>last_page</mat-icon>
        </button>
    </div>
</ng-template>
